import { useSelector } from "react-redux";

import { RootStateInterface } from "reducer";
import { ModalStateInterface } from "scenes/Modal/interfaces";
import { ModalTypes } from "./interfaces";

import ClassificationPointModal from "./ClassificationPointModal/ClassificationPointModal";
import DeleteModal from "./DeleteModal/DeleteModal";
import EditPolygonModal from "./EditPolygonModal/EditPolygonModal";
import FormModal from "./FormModal/FormModal";
import PreloaderModal from "./PreloaderModal/PreloaderModal";
import ProgressModal from "./ProgressModal/ProgressModal";
import ProviderFileManagerModal from "./ProviderFilesManagerModal/ProviderFilesManagerModal";
import ProviderFoldersFilesManagerModal from "./ProviderFoldersFilesManagerModal/ProviderFoldersFilesManagerModal";
import ProviderManagerModal from "./ProviderManagerModal/ProviderManagerModal";
import ShareProjectModal from "./ShareProjectModal/ShareProjectModal";
import SuccessModal from "./SuccessModal/SuccessModal";

export const MODAL_COMPONENTS: Record<ModalTypes, () => JSX.Element> = {
  [ModalTypes.PRELOADER]: PreloaderModal,
  [ModalTypes.PROGRESS]: ProgressModal,
  [ModalTypes.DELETE]: DeleteModal,
  [ModalTypes.FORM]: FormModal,
  [ModalTypes.SHARE_PROJECT]: ShareProjectModal,
  [ModalTypes.EDIT_POLYGON]: EditPolygonModal,
  [ModalTypes.SUCCESS]: SuccessModal,
  [ModalTypes.PROVIDER_MANAGER_MODAL]: ProviderManagerModal,
  [ModalTypes.PROVIDER_FILE_MANAGER_MODAL]: ProviderFileManagerModal,
  [ModalTypes.PROVIDER_FOLDERS_FILES_MANAGER_MODAL]:
    ProviderFoldersFilesManagerModal,
  [ModalTypes.CLASSIFICATION_POINT_MODAL]: ClassificationPointModal
};

const ModalRoot = () => {
  const { modalType, modalProps } = useSelector<
    RootStateInterface,
    ModalStateInterface
  >((state) => state.modal);

  if (!modalType) {
    return <></>;
  }

  const SpecificModal = MODAL_COMPONENTS[modalType];

  return <SpecificModal {...modalProps} />;
};

export default ModalRoot;
